import { createActions } from 'redux-actions'

import { createFormActions } from '../../utils/actions'

export const {
  jobmail: {
    unsubscribe,
    unsubscribeSuccess,
    unsubscribeFailure
  }
} = createActions({
  JOBMAIL: {
    ...createFormActions('UNSUBSCRIBE')
  }
})
